import { requestCaseStatus } from "./credit-assessment/get-status";
import { requestNewCase } from "./credit-assessment/new-case";
import { requestSignCase } from "./credit-assessment/sign";
import { requestCancelSignCase } from "./credit-assessment/cancel-sign";
import { requestDeclineCase } from "./credit-assessment/decline";
import { requestAcceptCase } from "./credit-assessment/accept";
const validate = (response) => {
    if (!response || !response.successful || !response.response) {
        throw new Error("The request did not succeed");
    }
    return response.response;
};
export const newCase = (inquiry) => requestNewCase(inquiry).then(validate);
export const getStatus = (caseId) => requestCaseStatus(caseId).then(validate);
export const signCase = (request) => requestSignCase(request).then(validate);
export const cancelSigning = (caseId) => requestCancelSignCase(caseId).then(() => true);
export const decline = (caseId) => requestDeclineCase(caseId).then(() => true);
export const accept = (caseId) => requestAcceptCase(caseId).then(() => true);
